import { UPGRADE_PLANS } from 'modules/billing/store/models/Plan'

export const planToUpgrade = (planFamily: string | null | undefined) => {
  if (!planFamily) return null

  return UPGRADE_PLANS[planFamily]
}
